var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.301,
    height: 19.301,
    viewBox: "0 0 19.301 19.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1314.668 -574.574)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1324.338,578.593h-.01a3.141,3.141,0,0,0-.009,6.282h.014a3.141,3.141,0,0,0,.005-6.282Zm-.02,4.981a1.849,1.849,0,1,1,1.85-1.849A1.85,1.85,0,0,1,1324.318,583.574Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1324.318,574.574a9.651,9.651,0,1,0,9.651,9.651A9.661,9.661,0,0,0,1324.318,574.574Zm5.149,16.205a8.24,8.24,0,0,1-10.3,0l-.218-.174.12-.251c.524-1.1,3.3-1.979,5.245-1.979h.008a9.983,9.983,0,0,1,3.122.572,3.743,3.743,0,0,1,2.077,1.343l.213.273Zm1.489-1.511-.268.349-.28-.34c-1.354-1.648-4.749-2.2-6.09-2.2s-4.735.555-6.089,2.2l-.279.341-.268-.349a8.349,8.349,0,1,1,13.274,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.9938754cb8ebc266d8c05c97b4b66502.svg";
export { ForwardRef as ReactComponent };